import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "editQuestionValueModalRef",
  id: "kt_modal_edit_question_value",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_edit_question_value_header"
}
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_edit_question_value_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_edit_question_value_header",
  "data-kt-scroll-wrappers": "#kt_modal_edit_question_value_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_10 = { class: "fs-5 fw-bold mb-2 required" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_14 = { class: "fs-5 fw-bold mb-2 required" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_18 = { class: "fs-5 fw-bold mb-2 required" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_22 = { class: "fs-5 fw-bold mb-2 required" }
const _hoisted_23 = { value: "" }
const _hoisted_24 = { value: "1" }
const _hoisted_25 = { value: "2" }
const _hoisted_26 = { value: "3" }
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "modal-footer flex-center" }
const _hoisted_30 = {
  "data-bs-dismiss": "modal",
  id: "kt_modal_edit_question_value_cancel",
  class: "btn btn-white me-3"
}
const _hoisted_31 = {
  key: 0,
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_edit_question_value_submit",
  class: "btn btn-primary"
}
const _hoisted_32 = { class: "indicator-label" }
const _hoisted_33 = { class: "indicator-progress" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_edit_question_value_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.translate('updateGroupQuestion')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.translate('arabicName')), 1),
                  _createVNode(_component_Field, {
                    type: "text",
                    autocomplete: "off",
                    class: "form-control form-control-solid",
                    placeholder: _ctx.translate('questionNameArLang'),
                    name: "titleAr",
                    modelValue: _ctx.question.titleAr,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.question.titleAr) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "titleAr" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate('englishName')), 1),
                  _createVNode(_component_Field, {
                    type: "text",
                    autocomplete: "off",
                    class: "form-control form-control-solid",
                    placeholder: _ctx.translate('questionNameEnLang'),
                    name: "titleEn",
                    modelValue: _ctx.question.titleEn,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.question.titleEn) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "titleEn" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('sort')), 1),
                  _createVNode(_component_Field, {
                    type: "number",
                    autocomplete: "off",
                    class: "form-control form-control-solid",
                    placeholder: _ctx.translate('sort'),
                    name: "sort",
                    modelValue: _ctx.question.sort,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.question.sort) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_ErrorMessage, { name: "sort" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.translate('componentType')), 1),
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "componentType",
                    class: "form-select form-select-solid",
                    modelValue: _ctx.question.componentType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.question.componentType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.translate('selectComponentType')), 1),
                      _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.translate('dropdown')), 1),
                      _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.translate('list')), 1),
                      _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.translate('checkbox')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_ErrorMessage, { name: "componentType" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("a", _hoisted_30, _toDisplayString(_ctx.translate('discard')), 1),
              (_ctx.can('update', 'ive'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_33, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_34
                    ])
                  ], 512))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}